import { useState } from "react";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import getStyles from "./styles";
import { useAppDispatch } from "../../redux";
import { setIsLoading } from "../../AppSlice";
import type { IPDFViewerProps } from "../../types";
import { Close } from "@mui/icons-material";
import { Box, Fab, Modal } from "@mui/material";
import { Document, Page, pdfjs } from "react-pdf";
//@ts-ignore
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default function _PDFViewer(props: IPDFViewerProps) {
  const { file, isOpen, close } = props;

  const styles = getStyles();

  const dispatch = useAppDispatch();

  const [numPages, setNumPages] = useState(0);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
    dispatch(setIsLoading(false));
  };

  const handleClose = () => {
    setNumPages(0);
    dispatch(setIsLoading(false));
    close();
  };

  return (
    <Modal
      open={isOpen}
      closeAfterTransition
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      sx={{
        visibility: numPages ? "visible" : "hidden",
      }}
    >
      <Box sx={styles.wrapper}>
        {file ? (
          <Document file={file} onLoadSuccess={onDocumentLoadSuccess} onLoadError={handleClose}>
            {Array.from(new Array(numPages), (_, index) => (
              <Page
                key={index}
                pageNumber={index + 1}
                renderTextLayer={false}
                width={window.outerWidth >= 920 ? window.innerWidth / 2 : window.innerWidth}
              />
            ))}
          </Document>
        ) : null}

        <Fab onClick={handleClose} sx={styles.close}>
          <Close />
        </Fab>
      </Box>
    </Modal>
  );
}
